import { useFocusableGroup } from '@fluentui/react-components';
export const useChatMessageFocusableGroup = (state)=>{
    const groupperAttributes = useFocusableGroup({
        tabBehavior: 'limited-trap-focus'
    });
    state.body['data-tabster'] = groupperAttributes['data-tabster'];
};

//# sourceMappingURL=useChatMessageFocusableGroup.js.map